module.exports = __webpack_public_path__ + "static/media/metacognition-large@2x.3748c43b.png";